const PagesData = {

    pageOptions: [
        {
            id: 1,
            previous: 'Inicio',
            next: '¿Qué es un bebé prematuro?'
        },
        {
            id: 2,
            previous: 'Inicio',
            next: 'Riesgos: respiración'
        },
        {
            id: 3,
            previous: '¿Qué es un bebé prematuro?',
            next: 'Riesgos: infecciones'
        },
        {
            id: 4,
            previous: 'Riesgos: respiración',
            next: 'Bronquiolitis y síntomas'
        },
        {
            id: 5,
            previous: 'Riesgos: infecciones',
            next: 'Bronquiolitis y signos de alarma'
        },
        {
            id: 6,
            previous: 'Bronquiolitis y síntomas',
            next: 'Prevención de VSR y virus respiratorios'
        },
        {
            id: 7,
            previous: 'Bronquiolitis y signos de alarma',
            next: 'En el hospital'
        },
        {
            id: 8,
            previous: 'Prevención de VSR y virus respiratorios',
            next: 'En casa: higiene y ambiente'
        },
        {
            id: 9,
            previous: 'En el hospital',
            next: 'En casa: visitas y método canguro'
        },
        {
            id: 10,
            previous: 'En casa: higiene y ambiente',
            next: 'Alimentación para bebés prematuros'
        },
        {
            id: 11,
            previous: 'En casa: visitas y método canguro',
            next: 'Posiciones para sacar gases'
        },
        {
            id: 12,
            previous: 'Alimentación para bebés prematuros',
            next: 'Dulces sueños'
        },
        {
            id: 13,
            previous: 'Posiciones para sacar gases',
            next: 'Cómo asear a mi bebé prematuro'
        },
        {
            id: 14,
            previous: 'Dulces sueños',
            next: 'Disfrute al máximo el tiempo con su bebé'
        },
        {
            id: 15,
            previous: 'Cómo asear a mi bebé prematuro',
            next: 'Disfrute al máximo el tiempo con su bebé'
        },
    ]
}

Object.freeze(PagesData);

export default PagesData;